<template>
    <v-app>
        <v-app-bar app color="white" light elevation="0" height="60" min-width="1200px" class="py-0" style="box-shadow: 0 3px 6px 0 rgba(225,225,225,0.50) !important;">
            <v-sheet class="big-box d-flex justify-space-between align-center">
                <v-sheet class="d-flex align-center">
                    <v-sheet class="mr-8" style="cursor: pointer;" @click="$router.push({ name: 'HomeView' })">
                        <v-img width="172" height="auto" src="../assets/images/logo.png"></v-img>
                    </v-sheet>
                    
                    <v-tabs v-model="tab" class="flex-grow-1" color="primary" height="60" :hide-slider="isHideSlider">
                        <v-tab link :to="{ name: 'HomeView' }">首页</v-tab>
                        <v-tab link :to="{ name: 'AllCourseList' }">全部课程</v-tab>
                        <v-tab v-if="admin && admin.userType === 'T'" link :to="{ name: 'CourseBuild' }">课程建设</v-tab>
                        <v-tab v-if="admin && admin.userType !== 'T'" link :to="{ name: 'JoinedCourses' }">我的课程</v-tab>
                    </v-tabs>
                </v-sheet>

                <v-btn v-if="!successfulLogin && !admin" color="primary" @click="loginDialogShown = true">登录</v-btn>
                <v-menu v-if="successfulLogin || admin" bottom rounded offset-y open-on-hover>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: pointer;">
                            <v-avatar size="40">
                                <img :src="admin.fullAvatarUrl" alt="Avatar">
                            </v-avatar>
                            <span class="ml-3">{{ admin.fullName }}</span>
                        </div>
                    </template>
                    <v-list class="text-center">
                        <v-list-item-group color="primary">
                            <v-list-item link :to="{ name: 'ProfileView' }">
                                <v-list-item-title>个人信息</v-list-item-title>
                            </v-list-item>
                            <v-list-item link :to="{ name: 'JoinedCourses' }">
                                <v-list-item-title>我的课程</v-list-item-title>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item @click="doLogout">
                                <v-list-item-title class="grey--text text--darken-2">退出登录</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-menu>
            </v-sheet>
        </v-app-bar>

        <v-main>
            <v-container fluid class="pa-0 white">
                <router-view></router-view>
            </v-container>

            <!-- 显示操作成功的浮层 -->
            <v-sheet v-if="successAlertBoxShown" class="success-info-box d-flex justify-center" color="transparent" style="z-index: 999999;">
                <v-alert
                    type="success"
                    dismissible
                    border="left"
                    transition="scale-transition"
                    origin="center center"
                    class="mb-0 info-alert"
                    v-model="successAlertShown">
                    {{ successAlertMessage }}
                </v-alert>
            </v-sheet>

            <!-- 显示操作失败的浮层 -->
            <v-sheet v-if="errorAlertBoxShown" class="success-info-box d-flex justify-center" color="transparent" style="z-index: 999999;">
                <v-alert
                    type="error"
                    dismissible
                    border="left"
                    transition="scale-transition"
                    origin="center center"
                    class="mb-0 info-alert"
                    icon="mdi-alert-circle"
                    v-model="errorAlertShown">
                    {{ errorAlertMessage }}
                </v-alert>
            </v-sheet>

            <!-- 显示警告的浮层 -->
            <v-sheet v-if="warningAlertBoxShown" class="success-info-box d-flex justify-center" color="transparent" style="z-index: 999999;">
                <v-alert
                    type="warning"
                    dismissible
                    border="left"
                    transition="scale-transition"
                    origin="center center"
                    class="mb-0 info-alert"
                    icon="mdi-alert-circle"
                    v-model="warningAlertShown">
                    {{ warningAlertMessage }}
                </v-alert>
            </v-sheet>

            <!-- The error dialog -->
            <v-dialog persistent width="600" v-model="errorDialogShown">
                <v-card>
                    <v-card-title class="error white--text">发生错误了</v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="py-4 grey--text text--darken-4">
                        {{ errorMessage }}
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions class="py-4">
                        <v-spacer></v-spacer>
                        <v-btn color="error" outlined @click="errorDialogShown = false">确定</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <m-login-dialog v-if="loginDialogShown" :loginDialogShown="loginDialogShown" @dealDialog="dealDialog"></m-login-dialog>
        </v-main>

        <m-footer v-if="!isHideFooter"></m-footer>

        <v-overlay v-if="stwLoadingShown" style="z-index: 99;">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-app>
</template>

<script>
import MFooter from '@/components/MFooter.vue';
import MLoginDialog from '@/components/MLoginDialog.vue';
import apiClient from '../api/user';

export default {
    name: 'NavigationView',
    components: {
        MFooter,
        MLoginDialog,
    },
    data: function() {
        return {
            successAlertMessage: null,
            successAlertShown: false,
            successAlertBoxShown: false,

            errorAlertMessage: null,
            errorAlertShown: false,
            errorAlertBoxShown: false,

            warningAlertBoxShown: null,
            warningAlertShown: null,
            warningAlertMessage: null,

            errorDialogShown: false,
            errorMessage: '这里是错误信息',

            userMessageCount: 0,

            loginDialogShown: false, //登录弹窗,
            successfulLogin: false, //成功登录
            admin: this.$store.getUser(),

            token: this.$route.query._token,

            tab: 0,

            stwLoadingShown: false,
        };
    },

    computed: {
        isHideSlider: function() {
            if (this.admin) {
                if (this.admin.userType === 'T') {
                    return this.$route.name !== 'HomeView' && this.$route.name !== 'AllCourseList' && this.$route.name !== 'CourseBuild'
                } else {
                    return this.$route.name !== 'HomeView' && this.$route.name !== 'AllCourseList' && this.$route.name !== 'JoinedCourses' ;
                }
            } else {
                return this.$route.name !== 'HomeView' && this.$route.name !== 'AllCourseList' && this.$route.name !== 'JoinedCourses' ;
            }
            
        },

        isHideFooter() {
            return this.$route.name === 'CourseLearning';
        }
    },

    created: function() {
        if (this.token) {
            this.getUserInfo();
        }
    },

    mounted: function() {
        window.addEventListener('message', this.onWindowMessage);
    },

    destroyed: function() {
        window.removeEventListener('message', this.onWindowMessage);
    },

    methods: {
        doLogout: function () {
            this.$router.push({
                name: 'HomeView'
            });
            this.admin = null;
            this.successfulLogin = false;
            this.$store.removeToken();
            this.$store.removeUser();
        },

        /**
         * Entrance of window message
         */
        onWindowMessage: function (evt) {
            const data = evt.data;
            switch (data.type) {
                case 'SHOW_LOGIN':
                    this.admin = null;
                    this.$store.removeToken();
                    this.$store.removeUser();
                    this.successfulLogin = false;
                    this.loginDialogShown = true;
                    return;
                case 'ERROR':
                    this.errorMessage = data.message;
                    this.errorDialogShown = true;
                    break;
                case 'SUCCESS_ALERT':
                    this.successAlertBoxShown = true;
                    this.successAlertMessage = data.message ? data.message : '操作成功';
                    // Show the v-alert component after the box has been created
                    // for better animation effect
                    this.$nextTick(() => {
                        this.successAlertShown = true;

                        setTimeout(() => {
                            this.successAlertShown = false;
                            this.$nextTick(() => {
                                this.successAlertBoxShown = false;
                            });
                        }, 2000);
                    });
                    break;
                case 'ERROR_ALERT':
                    this.errorAlertBoxShown = true;
                    this.errorAlertMessage = data.message ? data.message : '操作失败';
                    this.$nextTick(() => {
                        this.errorAlertShown = true;
                        setTimeout(() => {
                            this.errorAlertShown = false;
                            this.$nextTick(() => {
                                this.errorAlertBoxShown = false;
                            });
                        }, 2000);
                    });
                    break;
                case 'WARNING_ALERT':
                    this.warningAlertBoxShown = true;
                    this.warningAlertMessage = data.message ? data.message : '操作失败';
                    this.$nextTick(() => {
                        this.warningAlertShown = true;
                        setTimeout(() => {
                            this.warningAlertShown = false;
                            this.$nextTick(() => {
                                this.warningAlertBoxShown = false;
                            });
                        }, 2000);
                    });
                    break;
                case 'UPDATE_INFO':
                    this.admin = this.$store.getUser();
                    break;
                case 'SHOW_STOP_THE_WORLD_LOADING':
                    this.stwLoadingShown = true;
                    break;
                case 'HIDE_STOP_THE_WORLD_LOADING':
                    this.stwLoadingShown = false;
                    break;
                default:
            }
        },
        
        /**
         * 
         * @param {Boolean} close 是否关闭弹窗
         * @param {Boolean} val 是否登录成功
         */
        dealDialog(close, val) {
            this.loginDialogShown = close;

            if (val) {
                this.successfulLogin = true;
                this.admin = this.$store.getUser();

                location.reload();
            }

            
        },

        /**
         * 获取用户信息
         */
        getUserInfo: function() {
            const token = {
                token: this.token
            };
            apiClient.getUserInfo(token).then(resp => {
                if (resp.data.status) {
                    let user = resp.data.user;
                    this.admin = user;
                    this.$store.saveToken(resp.data.token);
                    this.$store.saveUser(user);
                    window.history.replaceState(null, null, this.gelDelURL());
                }
            }).catch(() => {
                window.history.replaceState(null, null, this.gelDelURL());
            }).finally(() => { });
        },

        gelDelURL() {
            return window.location.href.substring(0,window.location.href.indexOf("?"));
        },
    }
}
</script>

<style>

.big-box {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    max-width: 1200px;
    /* padding: 4px 16px; */
}

/* if the name is too long, ellipsis it */
.name-button span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /*max-width: 68px;*/
}

.success-info-box {
    position: fixed;
    bottom:  10px;
    width: 100%;
}

.success-info-box .v-alert__wrapper {
    min-width: 200px;
    max-width: 500px;
    margin: 0 auto;
}

</style>